const API_BASE = import.meta.env?.VITE_API_URL || "";

export interface SseSessionResponse {
  sessionToken: string;
  expiresAt: string;
}

export function buildSseStreamUrl(sessionToken: string): string {
  return `${API_BASE}/api/events/stream?session=${encodeURIComponent(sessionToken)}`;
}

export async function requestSseSessionToken(
  bearerToken: string,
  fetchImpl: typeof fetch = fetch,
): Promise<SseSessionResponse | null> {
  const response = await fetchImpl(`${API_BASE}/api/events/session`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
    },
  });

  if (!response.ok) return null;

  const json = await response.json();
  if (!json?.success || !json.data?.sessionToken) return null;
  return json.data as SseSessionResponse;
}
